import useIsGoogleDisabled from "clientState/useIsGoogleDisabled";

const useIsSocialAuthlDisabled = (): boolean => {
  const googleDisabled = useIsGoogleDisabled();

  const socialAuthMethods = [googleDisabled];

  return socialAuthMethods.every(Boolean);
};

export default useIsSocialAuthlDisabled;
